<template>
  <section
    id="hero"
    class="ml-6 mr-6"
  >
    <!--
    :src="require(`@/assets/images/water/RO_faucet_IMG_5498-10.JPG`)"
        :aspect-ratio="4/3"
    -->
    <v-container class="grey lighten-5">
      <span class="trace">docs.vue</span>
      <br>
      <h1>Docs for Truro Safe Water</h1>

      <p>
        <a
          href="https://www.dropbox.com/s/4ddfvy4sco0gybk/TruroPrivateWells-SafeWater_DTSW_ExecSummary_FINAL_091120.pdf?dl=0"
          target="_blank"
        >Executive Summary pdf (90KB)
        </a>
      </p>

      <p>
        <a
          href="https://www.dropbox.com/s/r2ecwgxg9nk57q5/TruroPrivateWells-SafeWater_DTSW%20Report_091120_Final.pdf?dl=0"
          target="_blank"
        >Full Report pdf (5MB)
        </a>
      </p>

      <p>
        <a
          href="https://www.dropbox.com/s/csyrpe4ub6zcy65/DocsTSW_Bios_091120.pdf?dl=0"
          target="_blank"
        >Docs Bios pdf (1MB)
        </a>
      </p>
    </v-container>
  </section>
</template>

<script>
  export default {
    name: 'Adapt',

    components: {
      // ToolbarWq: () => import('@/views/projects/ToolbarWq'),
    },

    data: () => ({
      // maxW: 800,
      youTube: true,
      currentValue: 475000,
      nitrateIncreasePercentDefault: 15,
      valuePerNitrateFactor: 0.61,
      valuePerLow: 0.407,
      valuePerHigh: 0.807,
      recentNitrate: 2.3,
      previousNitrate: 2.0,
      calculate: false,
      ex1: { label: 'color', val: 25, color: 'red' },
    }),

    computed: {
      adjustedValue () {
        const x = this.currentValue * (1 - 0.01 * this.nitrateIncreasePercent * this.valuePerNitrateFactor)
        return Math.round(x)
      },
      adjustedValueLow () {
        const x = this.currentValue * (1 - 0.01 * this.nitrateIncreasePercent * this.valuePerLow)
        return Math.round(x)
      },
      adjustedValueHigh () {
        const x = this.currentValue * (1 - 0.01 * this.nitrateIncreasePercent * this.valuePerHigh)
        return Math.round(x)
      },
      adjustedValueCommas () {
        return this.adjustedValue.toLocaleString()
        // return Number(parseFloat(this.adjustedValue.toFixed(0).toLocaleString('en', { minimumFractionDigits: 0 })))
      },

      lostValue () {
        const x = this.currentValue * (-0.01 * this.nitrateIncreasePercent * this.valuePerNitrateFactor)
        return Math.round(x)
      },
      lostValueLow () {
        const x = this.currentValue * (-0.01 * this.nitrateIncreasePercent * this.valuePerLow)
        return Math.round(x)
      },
      lostValueHigh () {
        const x = this.currentValue * (-0.01 * this.nitrateIncreasePercent * this.valuePerHigh)
        return Math.round(x)
      },
      lostValueCommas () {
        return this.lostValue.toLocaleString()
      },

      nitrateIncreasePercent () {
        if (this.recentNitrate > 0 && this.previousNitrate > 0) {
          return Math.round(100 * (this.recentNitrate / this.previousNitrate - 1))
        } else return this.nitrateIncreasePercentDefault
      },

    },

    methods: {
      wpClick: function (event) {
        this.$router.push({ name: 'splashWQ' })
      },
      sayMe: function (arg) {
        console.log(arg)
        // alert('ProjectCard.vue:' + this.graphic)
      },

    },

  }
</script>

<style scoped>
h1 {
  color: dodgerblue
}
</style>
